import logo from './logo.svg';
import './App.css';
import Form from './components/Form';
import Manager from './components/Manager';
import {
  Box, AppBar, Toolbar, Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import LogoAM from "./images/am.png";
import { useState } from "react";
import { useHistory ,useLocation } from 'react-router-dom';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from "@mui/material/TextField";
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { collection, addDoc, getDocs } from "firebase/firestore";
import {db} from './firebase';
import { useEffect } from 'react';
import QRCode from 'react-qr-code';
import Grid from "@mui/material/Grid";
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Html5QrcodeScanner } from 'html5-qrcode';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function App() {

  const [scanMode, setScanMode] = useState(false);
  const handleClicksetScanMode = () => {
    setScanMode(!scanMode);
  };
  const [scanResult, setScanResult] = useState(null);


  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);

  const handleSnackBar = () => {
    setOpenSnackBar(true);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackBar(false);
  };
 
  const [showManagger, setShowManagger] = useState(false);

  const [openLoader, setOpenLoader] = useState(false);
  const handleOpenLoader = () => setOpenLoader(true);
  const handleCloseLoader = () => setOpenLoader(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [openAbbonamentoDialog, setOpenAbbonamentoDialog] = useState(false);
  const handleClickOpenAbbonamentoDialog = () => {
    setOpenAbbonamentoDialog(true);
  };
  const [openModal, setOpenModel] = useState(false);
  const handleCloseModal = () => {
    setOpenModel(false);
  };

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCloseAbbonamentoDialog = () => {
    setOpenAbbonamentoDialog(false);
  };

  

  const verificaCredenziali = () => {
      setOpenDialog(false);
      fetchPost();
  };


  const [verificaUsernameField, setVerificaUsernameField] = useState("");
  const [verificaUsernameFieldError, setVerificaUsernameFieldError] = useState(false);
  const handleVerificaUsernameFieldChange = e => {
  setVerificaUsernameField(e.target.value);
  if (e.target.validity.valid) {
    setVerificaUsernameFieldError(false);
  } else {
    setVerificaUsernameFieldError(true);
  }
}

const [verificaAbbonamentoField, setVerificaAbbonamentoField] = useState("");
const handleVerificaAbbonamentoFieldChange = e => {
  setVerificaAbbonamentoField(e.target.value);
 
}

const [verificaPasswordField, setVerificaPasswordField] = useState("");
  const [verificaPasswordFieldError, setVerificaPasswordFieldError] = useState(false);
  const handleVerificaPasswordFieldChange = e => {
  setVerificaPasswordField(e.target.value);
  if (e.target.validity.valid) {
    setVerificaPasswordFieldError(false);
  } else {
    setVerificaPasswordFieldError(true);
  }
}

const fetchPost = async () => {
  handleOpenLoader(true);
  console.log("fetchPost");
  var founded = false;
  await getDocs(collection(db, "admin"))
      .then((querySnapshot)=>{              
          const newData = querySnapshot.docs.map((doc) => ({...doc.data()}));
          console.log(newData);
          querySnapshot.forEach(documentSnapshot => {
            const rowData = documentSnapshot.data();
            console.log(rowData);
            if(rowData.username.toLowerCase() === verificaUsernameField.toLowerCase()){
              if(rowData.pwd === verificaPasswordField){
                setShowManagger(true);
                handleCloseLoader(true);
                founded = true;
                return
              }else{
                handleCloseLoader(true);
                setOpenModel(true);
                return
              }
            }
          }
         );
         handleCloseLoader(true);
         setOpenModel(!founded);
        return
      })
}

const [apriAbbonamento, setApriAbbonamento] = useState("");
const [abbonamento, setAbbonamento] = useState("");
const [urlAbbonamento, setUrlAbbonamento] = useState(window.location.href);
let idAbbonamento = "";
/* useEffect(() => {
  console.log("urlAbbonamento  >>>>>> " + urlAbbonamento  );
  const strings = urlAbbonamento.split('/');
  console.log("strings " + strings);
  if(strings.length > 2){
    idAbbonamento = strings[strings.length - 1];
    console.log("Codice Abbonamento " + idAbbonamento);
    setApriAbbonamento(idAbbonamento);
    caricaAbbonamento(idAbbonamento);
  }
}, []); */

function visualizzaAbbonamento(){
  caricaAbbonamento();
}

const [varificaResult, setvarificaResult] = useState("");


const caricaAbbonamento = async () => {
  handleOpenLoader();
  console.log("caricaAbbonamento >>> " + verificaAbbonamentoField);
  var trovato = false;
  
  await getDocs(collection(db, "Abbonamento2026"))
    .then((querySnapshot)=>{              
        const newData = querySnapshot.docs.map((doc) => ({...doc.data()}));
        querySnapshot.forEach(documentSnapshot => {
          const rowData = documentSnapshot.data();
        
          if(documentSnapshot.id === verificaAbbonamentoField){
            console.log("caricaAbbonamento trovato >>> " + verificaAbbonamentoField);
            trovato = true;
            var datiAbbonato = rowData.nomeCognomeAbbonato !== "" ? (rowData.nomeCognomeAbbonato) : ("TITOLARE");
            var datiTitolare = rowData.nomeCognomeAbbonato !== "" ? ("TITOLARE " + rowData.nomeTitolare + " " + rowData.cognomeTitolare) : (rowData.nomeTitolare + " " + rowData.cognomeTitolare);
           
           setAbbonamento(<div >
              <Grid
                  container
                  sx={{ width: "100%",  paddingTop: 10, paddingBottom:5 }}
                  rowGap={3}
                > 
                
                  <Grid item xs={12} sx={{ width: "100%" }} id="print">
                  <Typography variant="h3"  align='center' paddingBottom={2}>CATEGORIA <strong>{rowData.categoriaTitolare.toUpperCase()}</strong></Typography>
                  <Typography variant="h3"  align='center' paddingBottom={2}>{rowData.turnoAbbonamento.toUpperCase()}</Typography>
                  <QRCode value={verificaAbbonamentoField} />
                  <Typography variant="h4"  align='center' paddingTop={2}><strong>{datiAbbonato}</strong></Typography>
                  <Typography variant="h5"  align='center' paddingTop={2}><strong>{datiTitolare}</strong></Typography>
                  <Typography variant="h4"  align='center' paddingTop={2}>OMBRELLONE N° <strong>{rowData.ombrellone.toUpperCase()}</strong></Typography>
                  <Typography variant="body2"  align='center' paddingTop={2}>Il Gestore si riserva la facoltà</Typography>
                  <Typography variant="body2"  align='center' paddingTop={0}>di effettuare controlli a campione</Typography>
                  <Typography variant="body2"  align='center' paddingTop={0}>sulla veridicità dei dati e della </Typography>
                  <Typography variant="body2"  align='center' paddingTop={0}>documentazione fornita.</Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ width: "100%" }}>
                  
                  {
                    (scanMode === false) ? ( <Button  variant="contained" onClick={() => {generatePDF(getTargetElement, options); setSnackBarMessage("Generazione PDF in corso.");
                      handleSnackBar();}}>SCARICA L'ABBONAMENTO IN FORMATO PDF</Button>) :(<></>)
                  }
                 
                  </Grid>
              </Grid>
              
            </div>);

            if(trovato === true){
              handleCloseAbbonamentoDialog();
              setApriAbbonamento(verificaAbbonamentoField);
            }
            handleCloseLoader(); 
          }
        }
      );
      handleCloseLoader(); 
  }) 
  return;
}
const options = {
  // default is `save`
  method: 'save',
  // default is Resolution.MEDIUM = 3, which should be enough, higher values
  // increases the image quality but also the size of the PDF, so be careful
  // using values higher than 10 when having multiple pages generated, it
  // might cause the page to crash or hang.
  resolution: Resolution.HIGH,
  page: {
     // margin is in MM, default is Margin.NONE = 0
     margin: Margin.NONE,
     // default is 'A4'
     format: 'letter',
     // default is 'portrait'
     orientation: 'portrait',
  },
  canvas: {
     // default is 'image/jpeg' for better size performance
     mimeType: 'image/png',
     qualityRatio: 1
  },
  // Customize any value passed to the jsPDF instance and html2canvas
  // function. You probably will not need this and things can break, 
  // so use with caution.
  overrides: {
     // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
     pdf: {
        compress: true
     },
     // see https://html2canvas.hertzen.com/configuration for more options
     canvas: {
        useCORS: true
     }
  },
};

const getTargetElement = () => document.getElementById('print');
var scanner;

function nuovaScansione(){
  scanner.clear();
  setvarificaResult(<></>);
  scanner.render(success, error);
}

useEffect(() => {
  setAbbonamento(<></>);
  scanner = new Html5QrcodeScanner('reader', {
    qrbox: {
      width:250,
      height:250,
    },
    fps: 10
  });

  scanner.render(success, error);
 
},[]);
function error(err){
  console.log(err);
}
async function success(result){
  scanner.clear();
  setScanResult(result);
  //window.alert(scanResult);
 
  var verificaResult;
  handleOpenLoader();
  await getDocs(collection(db, "Abbonamento2026"))
  .then((querySnapshot)=>{              
      const newData = querySnapshot.docs.map((doc) => ({...doc.data()}));
      var trovato = false;
      querySnapshot.forEach(documentSnapshot => {
        const rowData = documentSnapshot.data();
      
        if(documentSnapshot.id === result){
          console.log("caricaAbbonamento trovato >>> " + result);
          trovato = true;
          var datiAbbonato = rowData.nomeCognomeAbbonato !== "" ? (rowData.nomeCognomeAbbonato) : ("TITOLARE");
          var datiTitolare = rowData.nomeCognomeAbbonato !== "" ? ("TITOLARE " + rowData.nomeTitolare + " " + rowData.cognomeTitolare) : (rowData.nomeTitolare + " " + rowData.cognomeTitolare);
         
         verificaResult = <div>
            <Grid
                container
                sx={{ width: "100%",  paddingTop: 10, paddingBottom:5 }}
                rowGap={3}
              > 
              
                <Grid item xs={12} sx={{ width: "100%" }} id="print">
                <Typography variant="h3"  align='center' paddingBottom={2}>CATEGORIA <strong>{rowData.categoriaTitolare.toUpperCase()}</strong></Typography>
                <Typography variant="h3"  align='center' paddingBottom={2}>{rowData.turnoAbbonamento.toUpperCase()}</Typography>
                <Typography variant="h4"  align='center' paddingTop={2}><strong>{datiAbbonato}</strong></Typography>
                <Typography variant="h5"  align='center' paddingTop={2}><strong>{datiTitolare}</strong></Typography>
                <Typography variant="h4"  align='center' paddingTop={2}>OMBRELLONE N° <strong>{rowData.ombrellone.toUpperCase()}</strong></Typography>
                </Grid>
                <Button sx={{ width: "100%" }} variant="contained" onClick={() => {nuovaScansione()}}>OK</Button>
                <Grid item xs={12} sx={{ width: "100%" }}> 
                </Grid>
            </Grid>
            
          </div>;
        }
      }
    );
    if(trovato === false){
      setvarificaResult(<div><p>ABBONAMNETO NON TROVATO</p><Button  variant="contained" onClick={() => {nuovaScansione()}}>OK</Button></div>);
    }else{
      setvarificaResult(verificaResult);
    }
    handleCloseLoader(); 
}) 
handleCloseLoader(); 
}

  return (
    <div className="App"  sx={{ bgcolor: "#EDF2F6" }}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed" sx={{ bgcolor: "#FFFFFF", color: "#ACACAC" }}>
          <Toolbar>
          <Avatar
              src={LogoAM}
              sx={{ width: 60, height: 60, margin: 1 }}
              onClick={handleClickOpenDialog}
            ></Avatar>
            <Typography
              variant="h7"
              component="div"
              sx={{
                flexGrow: 1,
                textAlign: "left",
                color: "black",
                fontWeight: "bold",
              }}
            >
              Distaccamento Straordinario A.M. di "Miliscola" - Campagna Abbonamenti 2026
            </Typography>
            {/* <Button
             variant="contained"
            
             size='small'
             hidden={showManagger === true}
             onClick={handleClicksetScanMode}
             sx={{ margin:2}}
           >
          SCAN
           </Button> */}
             <Button
             variant="contained"
            
             size='small'
             hidden={showManagger === true}
             onClick={handleClickOpenAbbonamentoDialog}
           >
          IL TUO ABBONAMENTO
           </Button> 
          </Toolbar>
        </AppBar>
      </Box>
       <Box sx={{ paddingLeft: 2,
        paddingRight:5,
        paddingTop:20,
        }} >
         <div id='reader' hidden={!scanMode}></div>
        {scanMode === true ? <p>{varificaResult}</p> : <></>}
        {  scanMode === false  ? (  apriAbbonamento === "" ? ((showManagger === true) ? (<Manager/>) : (<Form/>)) : (<p>{abbonamento}</p>) ) : (<></>)}
       
       </Box>
       <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openLoader}
        onClick={handleCloseLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box  sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Controllo accesso
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Username o password errati
          </Typography>
          <Button onClick={handleCloseModal} sx={{paddingTop:2}}>OK</Button>
        </Box>
      </Modal>

       {/* Verifica DOmanda*/}
       <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            handleCloseDialog();
          },
        }}
      >
        <DialogTitle>Amministrazione</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Accedi al pannello amministrazione
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="username"
            name="username"
            label="Utente"
            type="text"
            fullWidth
            variant="standard"
            value={verificaUsernameField}
            onChange={handleVerificaUsernameFieldChange}
            onBlur={handleVerificaUsernameFieldChange}
            error={verificaUsernameFieldError}
            helperText={verificaUsernameFieldError ? "" : ""}
          />
           <TextField
            autoFocus
            required
            type="password"
            margin="dense"
            id="password"
            name="email"
            label="Password"
            fullWidth
            variant="standard"
            value={verificaPasswordField}
            onChange={handleVerificaPasswordFieldChange}
            onBlur={handleVerificaPasswordFieldChange}
            error={verificaPasswordFieldError}
            helperText={verificaPasswordFieldError ? "" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Annulla</Button>
          <Button type="submit" onClick={verificaCredenziali}>Invia</Button>
        </DialogActions>
      </Dialog>

       {/* Abbonamento*/}
       <Dialog
        open={openAbbonamentoDialog}
        onClose={handleCloseAbbonamentoDialog}
      >
        <DialogTitle>Visualizza il tuo abbonamento</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Inserisci il codice abbonamento che ti è stato inviato via email.<br></br>

          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            name="codicerichiesta"
            label="Codice Abbonamento"
            type="codicerichiesta"
            fullWidth
            variant="standard"
           
            value={verificaAbbonamentoField}
            onChange={handleVerificaAbbonamentoFieldChange}
            onBlur={handleVerificaAbbonamentoFieldChange}
          
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={visualizzaAbbonamento}>Ok</Button>
          <Button onClick={handleCloseAbbonamentoDialog}>Annulla</Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleCloseSnackBar}>
                <Alert
                  onClose={handleCloseSnackBar}
                  severity="success"
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  {snackBarMessage}
                </Alert>
              </Snackbar>
    </div>
  );
}

export default App;
